import request from "@/util/request"

export const Upload = (img: string): Promise<string> => {
  return request({
      url: '/admin/auth/user_upload',
      method: 'post',
      data: { img }
    })
};
